/**
* RegisteredFileTypes.ts
* @author Sid Dahiya (sidahiy)
* @copyright Microsoft 2020
* File containing an exhaustive list of known file types that Privacy Guard is searching for.
*/
export var RegisteredFileTypes = [
    "ACCDA",
    "ACCDB",
    "ACCDC",
    "ACCDE",
    "ACCDR",
    "ACCDT",
    "ACCDU",
    "ACCDW",
    "ACCFT",
    "ADE",
    "ADN",
    "ADP",
    "AVI",
    "BMP",
    "CSV",
    "DOC",
    "DOCX",
    "DOT",
    "DOTX",
    "ERR",
    "FON",
    "GIF",
    "HTML",
    "ISO",
    "JPEG",
    "JPG",
    "LACCDB",
    "LDB",
    "LOG",
    "MAD",
    "MAF",
    "MAG",
    "MAM",
    "MAQ",
    "MAR",
    "MAS",
    "MAT",
    "MAU",
    "MAV",
    "MAW",
    "MDA",
    "MDBHTML",
    "MDE",
    "MDN",
    "MDT",
    "MDW",
    "MOV",
    "MP3",
    "MPD",
    "MPG",
    "MPP",
    "MPT",
    "MPW",
    "MPX",
    "MSG",
    "OLS",
    "ONE",
    "ONEPKG",
    "ONETOC",
    "ONETOC2",
    "OST",
    "PDF",
    "PNG",
    "POT",
    "POTHTML",
    "POTX",
    "PPA",
    "PPS",
    "PPSX",
    "PPT",
    "PPTHTML",
    "PPTMHTML",
    "PPTX",
    "PPTXML",
    "PST",
    "PUB",
    "PWZ",
    "RTF",
    "SLDM",
    "SLDX",
    "SLK",
    "THMX",
    "TIF",
    "TIFF",
    "TSX",
    "TTF",
    "TXT",
    "VDW",
    "VDX",
    "VHD",
    "VSD",
    "VSDM",
    "VSDX",
    "VSIX",
    "VSL",
    "VSS",
    "VSSM",
    "VSSX",
    "VST",
    "VSTM",
    "VSTX",
    "VSU",
    "VSW",
    "VSX",
    "WAV",
    "WIZHTML",
    "WMA",
    "WMV",
    "WPL",
    "XLS",
    "XLSHTML",
    "XLSMHTML",
    "XLSX",
    "XLTHTML",
    "XLTM",
    "XLTX",
    "XLW",
    "XLXML",
    "XPS",
    "ZIP" // application/x-zip-compressed
];
var RegisteredFileTypesTrie = /** @class */ (function () {
    function RegisteredFileTypesTrie() {
        this.map = {};
        this.isWord = false;
        this.isInitialized = false;
    }
    RegisteredFileTypesTrie.prototype.search = function (word) {
        return this.find(word, 0, this);
    };
    RegisteredFileTypesTrie.prototype.init = function () {
        if (this.isInitialized) {
            return;
        }
        for (var _i = 0, RegisteredFileTypes_1 = RegisteredFileTypes; _i < RegisteredFileTypes_1.length; _i++) {
            var fileType = RegisteredFileTypes_1[_i];
            this.add(fileType, 0, this);
        }
        this.isInitialized = true;
    };
    RegisteredFileTypesTrie.prototype.add = function (word, index, letterMap) {
        if (index === word.length) {
            letterMap.isWord = true;
            return;
        }
        if (!letterMap.map[word.charAt(index)]) {
            letterMap.map[word.charAt(index)] = new RegisteredFileTypesTrie();
        }
        return this.add(word, index + 1, letterMap.map[word.charAt(index)]);
    };
    RegisteredFileTypesTrie.prototype.find = function (word, index, letterMap) {
        if (index === word.length) {
            if (letterMap.isWord) {
                return true;
            }
            return false;
        }
        if (letterMap.map[word[index]]) {
            return this.find(word, index + 1, letterMap.map[word.charAt(index)]);
        }
        return false;
    };
    return RegisteredFileTypesTrie;
}());
export { RegisteredFileTypesTrie };
//# sourceMappingURL=RegisteredFileTypes.js.map